module.exports = __webpack_public_path__ + "img/bg.19f5fc42.jpg";